export const orderByCode = (childrenFacetValues) => {
    return [...childrenFacetValues].sort((firstItem, secondItem) => (firstItem.code*1) - (secondItem.code*1));
};